var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.data),function(val,index){return [_c('gj-table',{key:index,ref:"gjTable",refInFor:true,staticClass:"table-bottom",attrs:{"data":val.item || [],"columns":_vm.expandColumns,"adapt-height":false,"width":"100%","index":false},scopedSlots:_vm._u([{key:"offerSellerId",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.offerSellerId))]}},{key:"listingPrice",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm._f("defaultShow")(_vm._f("amount")(row.listingPrice),row.listingPriceCurrencySymbol))+" ")]}},{key:"buyBoxWinner",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.buyBoxWinner ? "是" : "否"))]}},{key:"fulfillmentChannel",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.fulfillmentChannel))]}},{key:"fulfilledByAmazon",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.fulfilledByAmazon ? "亚马逊自营" : "普通卖家"))]}},{key:"followerInfo",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.positiveFeedbackRating + "% positive over the past 12 months.(" + row.feedbackCount + "total ratings)")+" ")]}},{key:"offerStartTime",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.offerStartTime))]}},{key:"offerEndTime",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.offerEndTime))]}}],null,true)})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }